import {PRODUCT_LIST_REQUEST,PRODUCT_LIST_SUCCESS,PRODUCT_LIST_FAIL} from '../constants/productConstants'
import Axios from 'axios';
import {PRODUCT_DETAILS_REQUEST, PRODUCT_DETAILS_SUCCESS, PRODUCT_DETAILS_FAIL} from '../constants/productConstants'
import { BASEURL } from '../../constant';

export const listProducts= () =>async(dispatch)=>{
    dispatch({
        type:PRODUCT_LIST_REQUEST,
    });
        try{
            const { data }= await Axios.get(`${BASEURL}/products`);
            dispatch({type:PRODUCT_LIST_SUCCESS, payload:data});
        }catch(error){
            dispatch({type:PRODUCT_LIST_FAIL, payload:error.message});
        }
};

export const DetailsProduct = (id) => async(dispatch)=>{
    dispatch({
        type:PRODUCT_DETAILS_REQUEST, 
    });
    try{
        const { data } = await Axios.get(`${BASEURL}/products/${id}`);
        dispatch({type:PRODUCT_DETAILS_SUCCESS, payload:data}); 
    }catch(error){
        dispatch({type:PRODUCT_DETAILS_FAIL, payload: error.response && error.response.data.message
        ?error.response.data.message:error.message
        })
    };
}
